import {HIDE_QUOTA_PAYWALL, SHOW_QUOTA_PAYWALL} from './actionTypes';

export const initialState = {
  visible: false,
  exhausted: null,
};

export default function subscriptionUi(state = initialState, action) {
  switch (action.type) {
    case SHOW_QUOTA_PAYWALL:
      return {
        visible: true,
        exhausted: {
          meter: action.payload?.meter || null,
          planKey: action.payload?.planKey || null,
          allowed: action.payload?.allowed ?? null,
          used: action.payload?.used ?? null,
          remaining: action.payload?.remaining ?? 0,
          resetAt: action.payload?.resetAt || null,
          message: action.payload?.message || null,
        },
      };
    case HIDE_QUOTA_PAYWALL:
      return initialState;
    default:
      return state;
  }
}
